import React, { useRef } from 'react';
import { PropTypes, describe } from 'react-desc';
import { isFunction } from '@elliemae/ds-utilities/utils';
import CloseXsmall from '@elliemae/ds-icons/CloseXsmall';
import useFocusGroupItem from '@elliemae/ds-shared/FocusGroup/useFocusGroupItem';
import { Pill } from './Pill.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@babel/runtime/helpers/esm/defineProperty';
import '@elliemae/ds-classnames';

function RemovablePill(_ref) {
  var _ref$containerProps = _ref.containerProps,
      containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      onRemove = _ref.onRemove,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'm' : _ref$size,
      leftAddon = _ref.leftAddon;
  var ref = useRef(null);

  var _useFocusGroupItem = useFocusGroupItem(ref),
      focusPrevious = _useFocusGroupItem.focusPrevious;

  return /*#__PURE__*/React.createElement(Pill, {
    className: "removable-pill",
    "data-testid": "removable-pill",
    containerProps: containerProps,
    innerRef: ref,
    size: size,
    label: label,
    leftAddon: leftAddon,
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Backspace' && isFunction(onRemove)) {
        onRemove();
        if (isFunction(focusPrevious)) focusPrevious();
      }
    },
    rightAddon: /*#__PURE__*/React.createElement(CloseXsmall, {
      role: "button",
      "data-testid": "remove-pill-button",
      className: "remove-pill-button",
      onClick: onRemove
    }),
    tabIndex: -1
  });
}

var props = {
  /** props injected to component wrapper */
  containerProps: PropTypes.object.description('props injected to component wrapper'),

  /** labeled pill text label */
  label: PropTypes.string.isRequired.description('pill text label'),

  /** remove click callback */
  onRemove: PropTypes.func.description('remove click callback'),

  /** pill size */
  size: PropTypes.oneOf(['m', 'l']).description('pill size'),

  /** addon component to left */
  leftAddon: PropTypes.node.description('addon component to left')
};
RemovablePill.propTypes = props;
var DSRemovablePillWithSchema = describe(RemovablePill);
DSRemovablePillWithSchema.propTypes = props;

export { DSRemovablePillWithSchema, RemovablePill };
//# sourceMappingURL=RemovablePill.js.map
